/* eslint-disable */
import request from './helpers'

export function createWebhook (data) {
    return request ({
        url: '/api/v1/webhook',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function listWebhook () {
    return request ({
        url: '/api/v1/webhook/list',
        method: 'get'
    })
}

export function deleteWebhook (id) {
    return request ({
        url: '/api/v1/webhook/' + id,
        method: 'delete'
    })
}

export function resetWebhook (id, data) {
    return request ({
        url: '/api/v1/webhook/reset/' + id,
        method: 'put',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}
